export function removeEmptyStrings(object: Record<string, unknown>) {
  return Object.entries(object).reduce((acc, [key, value]) => {
    if (value === '') {
      return acc;
    }

    return { ...acc, [key]: value };
  }, {});
}
